import { IUpdateContratoFinanceiroUseCase } from "../../../presentation/useCases/update/update_contrato_financeiro_use_case";
import { ContratoFinanceiro } from "../../models/contrato_financeiro";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * UpdateContratoFinanceiroUseCase
 */

export class UpdateContratoFinanceiroUseCase implements IUpdateContratoFinanceiroUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async updateContratoFinanceiro(form: ContratoFinanceiro): Promise<void> {
    await this.repository.updateContratoFinanceiro(form);
  }
}
